import initStoreFinder from '//www.99bikes.co.nz/cdn/shop/t/783/assets/99-store-finder.js?v=16197435022003999701773628349';
import initDeposits from '//www.99bikes.co.nz/cdn/shop/t/783/assets/99-deposits.js?v=170440501146800692031773627457';

document.addEventListener('DOMContentLoaded', () => {
  initStoreFinder();
  initDeposits();
});

//99B 20251016 -PO adding global Algolia tracking functions (to be used collections, search and pdp)
window.AlgoliaTracking = window.AlgoliaTracking || {};

//99B 20251103 -PO change to local storage approach (functions below currently not used)
window.AlgoliaTracking.trackSearchAttribution = async function (query_id, variant_id, product_id) {
  const clickData = {
    eventName: 'Product Added To Cart',
    index: 'shopify_products', 
    queryID: query_id,
    objectIDs: [variant_id],
    productId: product_id,
  };

  try {
      const localStorageKey = 'algolia_analytics_clicked_objects'; // Key

      // Get any data previously stored
      const previousClickItemsString =
        localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      // Add the current products data to local storage
      previousClickItems.push(clickData);
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems));
  } catch (error) {
    console.error(error);
  }
}

window.AlgoliaTracking.storeAddToCartEvent = async function (queryId,variantId) {
  let variantsAddedToCart = JSON.parse(await window.AlgoliaTracking.getCartAttribute('algolia-variants-added-to-cart'));
  if (!variantsAddedToCart) variantsAddedToCart = [];
  const existingVariant = variantsAddedToCart.find(event => event.variantId === variantId);
  if (existingVariant) {
    existingVariant.queryId = queryId
  }else{
    variantsAddedToCart.push({
      'variantId' : variantId,
      'queryId' : queryId
    });
  }
  window.AlgoliaTracking.updateCartAttribute('algolia-variants-added-to-cart',JSON.stringify(variantsAddedToCart));
}

//99B 20251016 -PO, taken from 99-stock-availability.js for storing item query ids
window.AlgoliaTracking.updateCartAttribute = function (key, value) {
  if (!window.theme.useCartAttributes) return;

  const attributes = { [key]: value };
  const body = JSON.stringify({ attributes });
  const fetchConfig = FoxTheme?.utils?.fetchConfig ? FoxTheme.utils.fetchConfig() : {};
  const cartUpdateUrl = FoxTheme?.routes?.cart_update_url || '/cart/update.js';

  fetch(cartUpdateUrl, Object.assign({}, fetchConfig, { body }));
}

//99B 20251016 -PO, get existing cart attributes to modify 
window.AlgoliaTracking.getCartAttribute = async function (key) {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      console.error(`Response from AJAX API get cart not ok.`);
      return null;
    }
    const data = await response.json();
    return data?.attributes?.[key] ?? null;
  } catch(error) {
    console.error(error);
    return null;
  }
}